import Network from '@/common/lib/Network';

export default {
  authSignin(authData) {
    return Network.execute('POST', 'CWEBS0000A', {}, {
      pmail: authData.username,
      pmdp: authData.password
    }, {
      'Content-Type': 'application/json'
    })
  },
  getValidateEmail(pmail) {
    return Network.execute('GET', 'CWEBS0072A', {
      pmail
    })
  },
  vSignUp(object) {

    let post_data = {
      ds_i: object
    };

    return Network.execute('POST', 'CWEBS0074A', {}, post_data, {
      'Content-Type': 'application/json'
    });
  },
  setNewPassword(pmdp, session_id, md5) {
    return Network.execute('POST', 'set_new_password', {pmdp, session_id, md5});
  }
};
